import ajax from './index'

//订单日志列表
export function getOssMsg() {
	return ajax.post(`v2/common/upload/oss_token`, {})
}
